import Component from '../abstracts/Component';
import { doAjax } from '../utils/ajaxUtil';

export default class NotifyProductUnavailableComponent extends Component {
  get COMPONENTNAME() {
    return 'NotifyProductUnavailableComponent';
  }

  get SELECTORS() {
    return {
      dialogContainer: '.js-product-unavailable',
      buttonBackToShopping: '[data-back-to-shopping]',
      buttonBackToShoppingPrimary: '[data-back-to-shopping="primary"]',
      buttonShowProductUnavailableForm: '[data-notify-button]',
      productUnavailableNotificationFormContainer: '[data-notify-form]',
      productUnavailableNotificationForm: '[data-notify-form] form',
      notifyMessage: '[data-notify-message]',
      notifyError: '[data-mail-errors]',
    };
  }

  constructor(compEl) {
    super(compEl);
    this.onAfterOpen = this.onAfterOpen.bind(this);
  }

  bindEvents() {
    this.$on(this.$customEvents.MODAL_EVENTS.show, ({ payload }) => {
      if (payload.type === 'product-unavailable') {
        setTimeout(this.onAfterOpen, 1000);
      }
    });
  }

  onAfterOpen() {
    // vars
    let dialogBox = document.querySelector(this.SELECTORS.dialogContainer);
    let formContainer = dialogBox.querySelector(this.SELECTORS.productUnavailableNotificationFormContainer);
    let form = dialogBox.querySelector(this.SELECTORS.productUnavailableNotificationForm);
    let formOpenBtn = dialogBox.querySelector(this.SELECTORS.buttonShowProductUnavailableForm);
    let formCloseBtns = dialogBox.querySelectorAll(this.SELECTORS.buttonBackToShopping);
    let formCloseBtnPrimary = dialogBox.querySelector(this.SELECTORS.buttonBackToShoppingPrimary);
    let notifyMessage = dialogBox.querySelector(this.SELECTORS.notifyMessage);
    let notifyError = dialogBox.querySelector(this.SELECTORS.notifyError);
    // click open
    if (formOpenBtn !== null) {
      formOpenBtn.addEventListener('click', function (){
        // show form
        formContainer.classList.remove('hidden');
        // hide buttons
        formOpenBtn.classList.add('hidden');
        formCloseBtnPrimary.classList.add('hidden');
      });
    }
    // click close
    if (formCloseBtns !== null) {
      formCloseBtns.forEach((btn)=>{
        btn.addEventListener('click', function (){
          dialogBox.closest('.vex').querySelector('.icon-close').click();
        });
      });
    }

    // intercept the form submit
    form.addEventListener("submit", function(e){
      // hide eventually error
      notifyError.classList.remove('show');
      // prevent the default and launch notify
      e.preventDefault();
      let endpoint = form.getAttribute('action');
      let payload = $(form).serialize();
      // go ajax
      doAjax({
        url: endpoint,
        data: payload,
        dataType: 'html',
        success: (response) => {
          // show response
          notifyMessage.innerHTML = response;
          notifyMessage.classList.remove('hidden');
          // hide form
          formContainer.classList.add('hidden');
          // reshow back btn
          formCloseBtnPrimary.classList.remove('hidden');
        },
        error: function(xhr){
          notifyError.innerHTML = xhr.responseText;
          if (notifyError.classList.contains('hidden')) {
            notifyError.classList.replace('hidden','show');
          } else {
            notifyError.classList.add('show');
          }

        }
      });
    });

  }

  render() {
    this.log("Rendering...");
    this.bindEvents();
  }
}
